import {Component, inject, Injector, OnInit, signal} from "@angular/core";
import {BasicMaterialDialog, MatDialogDataBaseInput} from "../../basic-material-dialog/basic-material-dialog.directive";
import {Translations} from "@translations";
import {SimMaterialDialogService, SimSessionService, SimUtilityService} from "@services";
import {ISimSession} from "@models";
import {zoomInOnEnterAnimation} from "angular-animations";

export interface DialogData_BlockingSessionDialogInput extends MatDialogDataBaseInput {
	sessionId: string;
}

@Component({
	selector: "sim-blocking-sessions-dialog",
	templateUrl: "./blocking-sessions-dialog.component.html",
	styleUrl: "./blocking-sessions-dialog.component.scss",
	animations: [zoomInOnEnterAnimation({duration: 150})],
	standalone: false,
})
export class BlockingSessionsDialogComponent
	extends BasicMaterialDialog<BlockingSessionsDialogComponent, DialogData_BlockingSessionDialogInput>
	implements OnInit
{
	// Constants
	public readonly T = Translations;
	protected readonly SimSessionService = SimSessionService;

	// Properties
	protected readonly isError = signal<boolean>(false);
	protected readonly sessions = signal<ISimSession[]>([]);
	protected readonly busyMap = signal<Map<string, Promise<void>>>(new Map<string, Promise<void>>());

	// Injections
	readonly #sessionService = inject(SimSessionService);
	readonly #dialogService = inject(SimMaterialDialogService);

	constructor(_injector: Injector) {
		super(_injector);
	}

	public async ngOnInit() {
		super.ngOnInit();
		try {
			const sessions = await this.#sessionService.getSessionsWithOccupiedRooms(this.data.sessionId);
			this.sessions.set(sessions);
		} catch {
			this.isError.set(true);
		}
	}

	protected async cancelSession(sessionId: string): Promise<void> {
		const {action} = await this.#dialogService.openConfirmationDialog({
			title: this.T.CONFIRMATION_DIALOG_ABORT_SESSION_TITLE,
			cancelText: this.T.BUTTON_CANCEL,
			description: this.T.CONFIRMATION_DIALOG_ABORT_SESSION_DESC,
			okText: this.T.BUTTON_OK,
		});
		if (action === "ok") {
			const promise = SimUtilityService.promiseTakeAtLeast(
				300,
				this.#sessionService
					.abortSession({sessionId})
					.then(() => this.sessions.update((sessions) => sessions.filter((x) => x.id !== sessionId))),
			);
			this.busyMap().set(sessionId, promise);
		}
	}
}
